import api, { ApiResponse, QueryPayload, QueryResponse, WhereCondition } from './api';
import type { ActivityEntry } from '../components/ActivityCell';

export interface LandingPage {
  activity_status?: ActivityEntry | null;
  id: string;
  seq?: number;
  ref?: string;
  workspace_id: string;
  tag_ids?: string[];
  name: string;
  notes?: string | null;
  url: string;
  status: string;
  created_at: string;
  updated_at: string;
}

export const landingPagesService = {
  query: async (filters: { limit?: number; offset?: number; search?: string; where?: WhereCondition ; order_by?: string; order?: 'asc' | 'desc' } = {}): Promise<{ data: LandingPage[]; total: number }> => {
    const where: WhereCondition | undefined = filters.where ?? (filters.search
      ? { landing_page: { name: { op: 'ilike', value: `%${filters.search}%` } } } : undefined);
    const payload: QueryPayload = {
      offset: filters.offset ?? 0,
      limit: filters.limit ?? 100,
      order_by: filters.order_by ?? 'landing_page.created_at',
      order: filters.order ?? 'desc',
      ...(where && { where }),
    };
    const response = await api.post<QueryResponse<LandingPage>>('/landing-pages/query', payload);
    return { data: response.data.data, total: response.data._meta?.total ?? 0 };
  },

  getById: async (id: string): Promise<LandingPage> => {
    const response = await api.get<ApiResponse<LandingPage>>(`/landing-pages/${id}`);
    return response.data.data!;
  },

  create: async (data: Partial<LandingPage>): Promise<LandingPage> => {
    const response = await api.post<ApiResponse<LandingPage>>('/landing-pages', data);
    return response.data.data!;
  },

  update: async (id: string, data: Partial<LandingPage>): Promise<LandingPage> => {
    const response = await api.patch<ApiResponse<LandingPage>>(`/landing-pages/${id}`, data);
    return response.data.data!;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/landing-pages/${id}`);
  },

  unarchive: async (id: string): Promise<LandingPage> => {
    const response = await api.patch<ApiResponse<LandingPage>>(`/landing-pages/${id}/unarchive`);
    return response.data.data!;
  },
};
